import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { Row, Col, Table, Button, ButtonGroup } from 'react-bootstrap';
import { BiSolidPrinter, BiRefresh } from 'react-icons/bi';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import '../../../shared/Shared.css';
import $ from 'jquery';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert';
import { VedikaService } from '../../../services/VedikaService';
import LoadingSpinner from '../../../shared/LoadingSpinner'

const Triase = () => {
    const [selectedData, setselectedData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [listTriase, setListTriase] = useState([]);


    const loadInit = async () => {
        setIsLoading(true)
        try {
            const promise1 = VedikaService.getHasilTriase($('#noRegistrasi').text());
            const allPromise = await Promise.all([promise1]);
            if (allPromise[0].data.hasilTriase.length == 0) {
                throw new Error('Maaf, Tidak ada data');
            }
            setListTriase(allPromise[0].data.hasilTriase);
        } catch (error) {
            swal({
                title: error.code,
                text: error.message,
                icon: "error",
                button: "OK",
            })
                .then((val) => {
                });
        } finally {
            setIsLoading(false)
        }
    }
    const reportTriase = (row) => {
        setselectedData(row)
        let urlService = 'https://vedika.rsabhk.co.id/service-reporting/daftar-triase-igd/'
        window.open(`${urlService}${row.norec}`, '_blank'); console.log(row)
    }

    const loaddtTriase = () => {
        $('#dtTriase').DataTable({
            data: listTriase,
            ordering: false,
            pageLength: 10,
            scrollCollapse: true,
            scrollY: '50vh',
            destroy: true,
            autoWidth: false,
            columns: [
                {
                    targets: [0],
                    data: null,
                    width: '5%',
                    createdCell: (td, cellData, rowData, row, col) => createRoot(td).render(<ButtonGroup aria-label="Basic example"><Button size='sm' variant="dark" data-bs-toggle="tooltip" data-bs-placement="right" title='Detail' onClick={() => reportTriase(rowData)}><BiSolidPrinter /></Button></ButtonGroup>),
                },
                {
                    targets: [1],
                    width: '10%',
                    data: 'beratbadan',
                },
                {
                    targets: [2],
                    width: '10%',
                    data: 'tekanandarah',
                },
                {
                    targets: [3],
                    width: '10%',
                    data: 'suhu',
                },
                {
                    targets: [4],
                    width: '10%',
                    data: 'nadi',
                },
                {
                    targets: [5],
                    width: '10%',
                    data: 'pernapasan',
                },
                {
                    targets: [6],
                    width: '15%',
                    data: 'namahasilkategoritriase',
                },
                {
                    targets: [7],
                    width: '15%',
                    data: 'tgl_diputuskan',
                },
            ]
        }, 100)
    }

    useEffect(() => {
        loaddtTriase();
    }, [listTriase])

    useEffect(() => {
        setTimeout(() => {
            loadInit()
        }, 1000);
    }, [])

    return (
        <React.Fragment>
            {isLoading ? (<LoadingSpinner />) : null}
            <Row>
                <Col md={10} className='text-center bg-success text-white'>
                    <h5>Triase</h5>
                </Col>
                <Col className='d-flex justify-content-center bg-light'>
                    <div className="d-flex flex-row-reverse bd-highlight">
                        <Button size='sm' variant='light' onClick={loadInit}><BiRefresh /> Refresh</Button>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Table responsive="sm" size="sm" id='dtTriase' bordered hover style={{ fontSize: 'smaller' }}>
                        <thead>
                            <tr>
                                <th></th>
                                <th>Berat Badan</th>
                                <th>Tekanan Darah</th>
                                <th>Suhu</th>
                                <th>Nadi</th>
                                <th>Pernapasan</th>
                                <th>Hasil</th>
                                <th>Tanggal Ditetapkan</th>
                            </tr>
                        </thead>
                    </Table>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default Triase;